import classNames from 'classnames';
import React, { FC, HTMLProps } from 'react';
import styles from './PageHeader.module.scss';

interface IPageHeaderProps extends HTMLProps<HTMLDivElement> {
  title?: string
}

const PageHeader: FC<IPageHeaderProps> = ({ title, children, className }) => (
  <div className={classNames(className, styles.pageHeader)}>
    <h1>{title}</h1>
    {children}
  </div>
);

export default PageHeader;
